import { Play, Promotion, Translate } from '@nackle/arcade-core-v2';
import { NackleProgramTile, Button, Tag } from '@nackle/origami';
import { CaretRight } from '@nackle/origami-icons';
import Hero from 'components/hero';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FALLBACK_ARCADE_IMAGE } from '../../assets';
import { getUmbrellaImageUrl } from '../utils/umbrellaImageUrl';
import translationCache from '../../utils/cache';
import './GameBanner.less';

const mapStateToProps = ( state ) => {
  const arcade =
    state.games.arcadeList.isLoaded && state.games.arcadeList.data[ 0 ];
  const maybePromotedGame = Promotion.getPromotedGame( state );
  const playsAvailableCount =
    ( maybePromotedGame.isLoaded &&
      maybePromotedGame.data &&
      Play.countCabinetPlaysAvailable(
        state,
        maybePromotedGame.data.cabinetId,
        maybePromotedGame.data.roomId,
      ) ) ||
    0;
  const playTokenIds =
    maybePromotedGame.isLoaded &&
    maybePromotedGame.data &&
    Play.getTokensIdsToPlay(
      state,
      maybePromotedGame.data.cabinetId,
      maybePromotedGame.data.roomId,
    );

  return {
    arcadeBannerImage:
      ( arcade && arcade.bannerImageUrl ) || FALLBACK_ARCADE_IMAGE,
    maybePromotedGame,
    playsAvailableCount,
    playTokenIds,
  };
};

const mapDispatchToProps = {
  openGame: Play.openGame,
};

class GameBanner extends Component {
  state = {
    cacheBundle: translationCache.mergedBundle,
  };

  unsubscribeTranslationCache = null;

  componentDidMount() {
    this.unsubscribeTranslationCache = translationCache.subscribe( ( mergedBundle ) => {
      this.setState( { cacheBundle: mergedBundle } );
    } );
  }

  componentWillUnmount() {
    if ( this.unsubscribeTranslationCache ) {
      this.unsubscribeTranslationCache();
    }
  }

  render() {
    const {
      arcadeBannerImage,
      maybePromotedGame,
      playsAvailableCount,
      isUmbrella,
    } = this.props;
    const { cacheBundle } = this.state;
    const fallbackTitle =  <Translate id={ 'arcade.webapp.noGameplay' }  />;
    const fallbackDescription = <Translate id={ 'arcade.webapp.noGameplayDescription' }  />;
    const fallbackImage = arcadeBannerImage;

    if ( !maybePromotedGame.isLoaded ) {
      return <Hero />;
    }

    const promotedGame = maybePromotedGame.data;
  const romId = promotedGame?.romId;
  const romName = cacheBundle[ `rom.${ romId }.name` ];
  const romDescription = cacheBundle[ `rom.${ romId }.description` ];

    if ( !promotedGame || playsAvailableCount === 0 ) {
      return (
        <>
          <NackleProgramTile
            title={ fallbackTitle }
            description={ fallbackDescription }
            imgSrc={ fallbackImage }
            imgAlt="Program Image"
          />
        </>
      );
    }

    return (
      <>
         <div
          className="game-feature"
        >
          <div className="tile-wrapper">
            { /* Overlay badge */ }
            <div className="featured-badge">
              <Tag.Color size="small" status="warning" style={ { fontSize: '14px' } }>
                <Translate id={ 'arcade.webapp.featuredGame' } />
              </Tag.Color>
            </div>
            <NackleProgramTile
              title={ romName }
              description={ romDescription }
              imgSrc={
                getUmbrellaImageUrl(
                  promotedGame.bannerImage,
                  isUmbrella,
                  arcadeBannerImage || FALLBACK_ARCADE_IMAGE,
                )
              }
              imgAlt="Program Image"
              extra={
                <div className="extra">
                  <Button
                    size="large"
                    shape="round"
                    disabled={ !playsAvailableCount }
                    onClick={ this.handleClick }
                    rightIcon={ <CaretRight /> }
                    type="primary"
                  >
                    <Translate id={ 'arcade.webapp.playButton' } />
                  </Button>
                  <div className="right">
                    <Tag.Color size="medium" status="processing">
                       { playsAvailableCount === 1 ? (
                        <>
                          { playsAvailableCount }{ ' ' }
                          <Translate id={ 'arcade.webapp.gamePlay' } />
                        </>
                      ) : (
                        <>
                          { playsAvailableCount }{ ' ' }
                          <Translate id={ 'arcade.webapp.gamePlays' } />
                        </>
                      ) }
                    </Tag.Color>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </>
    );
  }

  handleClick = async () => {

    try {
    const { maybePromotedGame, openGame, playTokenIds } = this.props;
      if ( !maybePromotedGame.isLoaded || !playTokenIds ) {
        return;
      }

      const promotedGame = maybePromotedGame.data;

      if ( !promotedGame ) {
        return;
      }
      await openGame( promotedGame.cabinetId, promotedGame.roomId );
    } catch ( e ) {
      console.error( e );
    }
  };
}

export default connect( mapStateToProps, mapDispatchToProps )( GameBanner );
